'use client';

import { Button } from '@/components/ui/Button';
import { Icon } from '@/components/ui/Icon';
import { Container } from '@/components/ui/Section';
import { CONTACT_EMAIL } from '@/config/env';
import { ROUTES } from '@/config/routes';

export interface CtaBannerProps {
  title?: string;
  description?: string;
  primaryLabel?: string;
  primaryTo?: string;
}

export function CtaBanner({
  title = 'Contact us today to become a partner',
  description = 'Tell us about your location and we will recommend the right model, quote shipping and get your LaunchPad installed.',
  primaryLabel = 'Get a LaunchPad',
  primaryTo = ROUTES.buy,
}: CtaBannerProps) {
  return (
    <section className="py-16 sm:py-20">
      <Container>
        <div className="border-brand/40 from-brand-deep/30 via-surface to-accent/15 relative overflow-hidden rounded-[2rem] border bg-gradient-to-r px-6 py-12 text-center sm:px-12 sm:py-16">
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 opacity-20 [background-image:radial-gradient(circle_at_20%_20%,#5cb8ff,transparent_45%),radial-gradient(circle_at_80%_80%,#22d3ee,transparent_45%)]"
          />
          <div className="relative flex flex-col items-center gap-6">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl">{title}</h2>
            <p className="text-content-muted max-w-2xl text-base sm:text-lg">{description}</p>
            <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
              <Button size="lg" to={primaryTo}>
                {primaryLabel}
                <Icon name="arrow" className="h-5 w-5" />
              </Button>
              <Button size="lg" variant="secondary" href={`mailto:${CONTACT_EMAIL}`}>
                <Icon name="mail" className="h-5 w-5" />
                Email us
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
